import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { tokens } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { refreshMe(); }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    tokens.set(data.access_token, data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const requestOtp = async (email) => {
    const { data } = await api.post("/auth/otp/request", { email });
    return data;
  };

  const verifyOtp = async (email, code) => {
    const { data } = await api.post("/auth/otp/verify", { email, code });
    tokens.set(data.access_token, data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    tokens.clear();
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, requestOtp, verifyOtp, logout, refreshMe }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const isAdmin = (u) => u && (u.role === "coach_admin" || u.role === "super_admin");
export const isCoach = (u) => u && (u.role === "coach" || isAdmin(u));
export const roleLabel = (role) => ({
  coach_admin: "Coach Admin",
  super_admin: "Super Admin",
  coach: "Coach",
  client: "Client",
}[role] || role);
